import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  image: {
    maxWidth: '100%',
    maxHeight: '80vh',
    objectFit: 'contain',
  },
}));

const PagePreview = ({ open, onClose, catalogId, pageNum, catalogName }) => {
  const classes = useStyles();

  if (!catalogId || pageNum == null) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <div className={classes.titleBar}>
        <DialogTitle disableTypography style={{ padding: 0 }}>
          {catalogName ? `${catalogName} - Page ${pageNum}` : `Page ${pageNum}`}
        </DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.content}>
        <img
          className={classes.image}
          src={`/api/vendor-catalogs/${catalogId}/page-image/${pageNum}`}
          alt={`Catalog page ${pageNum}`}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PagePreview;
